import React from "react";
import "../CSS/FounderInfo.css";
import Image from "../Images/About-2.png";
import OwnerImg from "../Images/OwnerImage.jpg";

const FounderInfo = () => {

    const startingYear = 2005;
    const currentYear = new Date().getFullYear();
    const yearsOfExperience = currentYear - startingYear; 

    return (
        <section className="ftco-section ftco-foundersection">
            <h1 className="text-center blackthemegradient">Founder</h1>
            <div className="container mt-5">
                <div className="row block-9 founder-container">
                    <div className="col-md-7 founder-info ftco-animate">
                        <div className="founderinfo">
                            <h4 className="text-left blackthemegradient">Janaki Pandiyarajan</h4>
                            <p className="text-left text-white">Years of Experience: {yearsOfExperience}+ years</p>
                            <p className="text-left text-white">
                                “At Janushree Ladies Parlour, my goal has always been to create a welcoming and empowering space for women to feel their best. Beauty is not just about the services we offer, but about the confidence and joy it brings to every woman who walks through our doors. With years of experience and a passion for enhancing natural beauty, my team and I are dedicated to delivering personalized care and top-notch services in a friendly and comfortable environment. Thank you for trusting us with your beauty journey!”
                            </p>
                        </div>
                    </div>
                    <div className="col-md-5 founder-image">
                        <img src={OwnerImg} alt="founder"/>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FounderInfo;
